<!--

This is a clickable component that is used to manage a module. You can view,
add, and delete users from a module via this component.

-->

<template>
  <div class="row"
        :class="{'bg-white': isEven,
                'bg-grey-01': isOdd,
                'bg-primary-02': isSelected}">
  <div class="col">

    <div
      v-if="showCloser == false"
      class="expand-all p-3 show-cursor"
      :class="{'link-hover': notSelected}"
      @click="displayMenu()">

      <div>{{name}}</div>
    </div>

    <div v-if="showCloser == true" class="row justify-end">
      <div @click="closeMenu()" class="col bg-primary text-center text-white text-bold font-size-2 show-cursor p-1">
        CLOSE (X)
      </div>
    </div>

    <div v-if="hidden == false" class="mt-3 p-3">
      <div class="row">
        <div class="col-md-6">

          <div class="row">
            <div class="col">
              <h3 class="text-primary text-underline">Module Name (<span style="color: black;">{{id}}</span>)</h3>
              <input type="text" v-model="name" class="form-control" />
            </div>
          </div>

          <div class="row">
            <div class="col">
              <h3 class="text-primary text-underline mt-3">Module Users</h3>

              <ul class="list-group list-group-flush mb-3">
                <li v-for="item in userList" class="list-group-item">
                  <div class="row justify-content-between align-items-center">
                    <div class="note-name col-9">
                      {{item.username}}
                    </div>

                    <div class="col-3 pr-2">
                      <button type="button" @click="deleteUserCheck(item.id)" class="btn btn-primary">Remove</button>
                    </div>
                  </div>
                </li>
              </ul>

              <button type="button" @click="getAllUsers()" class="btn btn-dark">Add A New User</button>

              <div v-for="user in moduleUsers" class="padding-top-05">
                <input type="checkbox" :value="user.id" v-model="userChecked" /> {{user.username}}
              </div>
            </div>
          </div>

        </div>

        <div class="col-md-6 pl-5">
          <h3 class="text-primary text-underline">Module Notes</h3>
          <div class="mb-5">
              <div class="form-inline">
                <input type="text" v-model="newnote" class="form-control" />
                <button type="button" @click="addNote()" class="btn btn-dark ml-2">Add Note</button>
              </div>

              <div class="mb-2 mt-3 text-bold">Choose Note Type</div>
              <select v-model="noteType">
                <option v-bind:value="1">Text</option>
                <option v-bind:value="2">Image</option>
                <option v-bind:value="3">Document List</option>
              </select>
          </div>
          <hr />

          <!-- shows notes for this module -->
          <h3 class="text-primary text-underline mt-3">Note List</h3>
          <div v-for="note in moduleNotes">
            <div class="row justify-conent-between mb-2">
              <div class="col-9 text-bold">
                {{note.name}}
              </div>
              <div class="col-3 note-list-button">
                <button type="button" @click="deleteNoteCheck(note.id)" class="btn btn-primary">Remove</button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <hr />

      <div class="row justify-content-between mt-3">
        <div class="col-auto">
          <button type="button" @click="saveModule()" class="btn btn-dark">Save</button>
        </div>

        <div class="col-auto">
          <button type="button" @click="deleteCheck()" class="btn btn-danger">Delete Module</button>
        </div>
      </div>

    </div>

    <!-- modal window for verifying module deletion -->
    <modal-window
    text-value="Delete Module?" 
    v-show="moduleModalOpened"
    v-on:close-modal="closeModuleModal"
    v-on:yes-click="deleteModule(id)"></modal-window>

    <!-- modal window for verifying note deletion -->
    <modal-window
    text-value="Delete Note?" 
    v-show="noteModalOpened"
    v-on:close-modal="closeNoteModal"
    v-on:yes-click="deleteNote"></modal-window>

    <!-- modal window for verifying user removal -->
    <modal-window
    text-value="Remove User?" 
    v-show="userModalOpened"
    v-on:close-modal="closeUserModal"
    v-on:yes-click="deleteUser"></modal-window>

  </div>
  </div>
</template>

<script>
import axios from 'axios'
import ModalWindow from '@/components/display-utils/ModalWindow.vue'

export default {
  components: {
    ModalWindow
  },
  data () {
    return {
      hidden: true,
      isEven: false,
      isOdd: false,
      isSelected: false,
      notSelected: true,
      showCloser: false,
      newnote: "",
      moduleUsers: [],
      moduleNotes: [],
      userList: [],
      userChecked: [],
      noteType: 1,
      moduleModalOpened: false,
      noteForDeletion: 0,
      noteModalOpened: false,
      userModalOpened: false,
      userForRemoval: 0
    }
  },
  props: ['id','name','count'],
  mounted: function() {
    this.checkPosition()
  },
  methods: {
    checkPosition: function() {
      if (this.count % 2 == 0) {
        this.isEven = true
        this.isOdd = false
      } else {
        this.isEven = false
        this.isOdd = true
      }
    },

    displayMenu: function() {
      //disable features if it's selected for editing
      if (this.isSelected == true) {
        return
      }

      if (this.hidden == false) { //hide it
        this.hidden = true
        this.toggleSelected(false)
      } else {                   //show it
        this.getModuleNotes()
        this.getUsers()
        this.hidden = false
        this.toggleSelected(true)

        //emit data upward to show notes for correct module
        this.$emit('load-notes', this.id)
      }
    },

    closeMenu: function() {
      this.hidden = true
      this.toggleSelected(false)
      
      //reset notes array to show no notes
      this.$emit('unload-notes')
      this.$emit('unload-modules')
    },

    toggleSelected: function(state) {
      if (state == true) {
        this.isEven = false
        this.isOdd = false
        this.isSelected = true
        this.notSelected = false
        this.showCloser = true
      } else {
        this.isSelected = false
        this.notSelected = true
        this.showCloser = false
        this.checkPosition()
      }
    },

    getMenuStatus: function() {
      let hidden = this.hidden

      let status = (function(hidden){
        return this.hidden
      })

      return status
    },

    saveModule: function() {
      //save users to the currently selected module

      //set local
      let local = this
      let req = {}

      req.moduleid = this.id
      req.userid = this.userChecked

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/module/users/save',
          data: req,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //reload page to clear module selections (on all of them)
          location.reload()
        })
        .catch(function (error) {
          console.log("login error: ", error)
        });
    },

    deleteCheck: function() {
      this.moduleModalOpened = true
    },

    deleteModule: function(id) {
      let local = this
      
      let req = {}
      req.id = id

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/module/delete',
          data: req,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //close window and refresh module list
          local.moduleModalOpened = false
          //local.$emit('reload-modules')
          local.$emit('unload-notes')
          local.$emit('load-notes')
        })
        .catch(function (error) {
          console.log(error)
        });
    },

    deleteUserCheck: function(id) {
      this.userForRemoval = id
      this.userModalOpened = true
    },

    deleteUser: function() {
      //delete user to module assocation

      //set local
      let local = this
      let req = {}
      let userArr = []
      userArr.push(this.userForRemoval) //api route taken an array

      req.moduleid = this.id
      req.userid = userArr

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/module/users/delete',
          data: req,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //refresh user list
          local.getUsers()
        })
        .catch(function (error) {
          console.log("user removal error: ", error)
        });

      this.userForRemoval = 0
      this.userModalOpened = false
    },

    closeUserModal: function() {
      this.userModalOpened = false
      this.userForRemoval = 0
    },

    getUsers: function() {
      //set local
      let local = this
      let req = {}
      req.id = this.id

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/module/users/get',
          data: req,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          local.userList = response.data
        })
        .catch(function (error) {
          console.log("login error: ", error)
        });
    },

    getAllUsers: function() {
      //get all non-admin level users to populate
      //the "add" list

      //set local
      let local = this
      let req = {}
      req.id = this.id

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/module/users/all',
          data: req,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json',
                    'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          local.moduleUsers = response.data
        })
        .catch(function (error) {
          console.log("login error: ", error)
        });
    },

    getModuleNotes: function() {
      //component reference
      let local = this

      //ajax query
      axios({
          method: 'get',
          url: local.$helpers.api() + '/module/notes/' + this.id,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'}
        })
        .then(function (response) {
          local.moduleNotes = response.data
        })
        .catch(function (error) {
          console.log("error geting module data: ", error)
        });
    },

    addNote: function() {
      //component reference
      let local = this
      let req = {}
      req.id = this.id //module id
      req.name = this.newnote //new note name
      req.note_type = this.noteType //note type

      //ajax query
      axios({
        method: 'post',
        url: this.$helpers.api() + '/admin/module/note/create',
        data: req,
        headers: {'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'application/json',
                  'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //refresh notes
          local.getModuleNotes()
          local.newnote = undefined
          local.$store.commit('setModulecheck',true)
        })
        .catch(function (error) {
          console.log("not logged in: ", error)
        });
    },

    deleteNoteCheck: function(id) {
      //since this is called during a for loop, we need to store
      //the id somewhere momentarily
      this.noteForDeletion = id
      this.noteModalOpened = true
    },

    closeNoteModal: function() {
      this.noteModalOpened = false
      this.noteForDeletion = 0
    },

    closeModuleModal: function() {
      this.moduleModalOpened = false
    },

    deleteNote: function() {
      //component reference
      let local = this
      let req = {}

      //make sure you're not trying to delete a null note (ie. 0)
      if (this.noteForDeletion === 0) {
        return
      }

      req.id = this.noteForDeletion

      //ajax query
      axios({
        method: 'post',
        url: this.$helpers.api() + '/admin/module/note/delete',
        data: req,
        headers: {'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'application/json',
                  'User-Token': local.$helpers.getToken()}
        })
        .then(function (response) {
          //refresh notes
          local.getModuleNotes()
          local.$emit('unload-notes') //unload current notes
          local.$emit('load-notes', local.id) //reload notes in parent
          local.$store.commit('setModulecheck',true)
          local.noteForDeletion = 0
          local.noteModalOpened = false
        })
        .catch(function (error) {
          console.log("not logged in: ", error)
          local.noteForDeletion = 0
        });
    }
  }
}
</script>

<style scoped>
  .expand_all {
    width: 100%;
    height: 100%;
  }

  .button-line {
    overflow: hidden;
    padding-right: .5em;
  }

  .note-list {
    display: flex;
  }

  .note-list-button button {
    justify-content: flex-end;
  }

  .note-filler {
    flex-grow: 1;
  }

  .q-if::before {
    background-color: black !important;
  }

</style>
